// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["dist/theme","dist/backpack-custom"], () => (__webpack_require__("./resources/js/index.ts")))
__webpack_require__.O(undefined, ["dist/theme","dist/backpack-custom"], () => (__webpack_require__("./resources/sass/theme.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["dist/theme","dist/backpack-custom"], () => (__webpack_require__("./resources/css/backpack-custom.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
